import React from "react";
import dontPg from '../../assets/img/noData.png'
import {useNavigate} from "react-router-dom";
import useTheme from "../../components/web/layoutscommon/DarkModeStorage";
import "../../css/web/UserPageRenew.css";

function ErrorPathPg() {

    const navigate = useNavigate();
    const [theme] = useTheme();

    const pathName = window.location.pathname;

    // const moveToMainPg = (() => {
    //     if (pathName.startsWith("/btcorpad")) {
    //         navigate("/btcorpad")
    //     } else {
    //     navigate("/")
    //     }
    // })

    const moveToMainPg = (() => {
            navigate("/")
    })

    return (
        <div className="up-scope up-page" data-theme={theme}>
            <div className="up-result-wrap">
                <div className="up-result">
                    <img className="up-result-icon" style={{width: "96px", height: "96px"}} src={dontPg} alt="not found"/>
                    <p className="up-result-title">This page does not exist</p>
                    <div className="up-btn-row" style={{justifyContent: "center", marginTop: "22px"}}>
                        <button className="up-btn-primary" style={{height: "50px", fontSize: "16px", maxWidth: "200px", margin: "0 auto"}}
                                onClick={moveToMainPg}>HOME
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ErrorPathPg
